import React, { useEffect, useRef, useState } from 'react';
import { IconVolume, IconVolumeOff } from './Icons';
import { SOUNDS, SoundId } from './sound';

/** The button and the list of page-turn sounds (same look as the page-turning list). */
export function SoundMenu({ value, onChange }: { value: SoundId; onChange: (s: SoundId) => void }) {
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (!open) return;
    const away = (e: MouseEvent | TouchEvent) => {
      if (box.current && !box.current.contains(e.target as Node)) setOpen(false);
    };
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', away);
    document.addEventListener('touchstart', away);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', away);
      document.removeEventListener('touchstart', away);
      document.removeEventListener('keydown', esc);
    };
  }, [open]);
  const name = SOUNDS.find((s) => s.id === value)?.label ?? '';
  const Icon = value === 'off' ? IconVolumeOff : IconVolume;
  return (
    <span className="info-item turn-menu sound-menu" ref={box}>
      <button className="icon-btn turn-btn" onClick={() => setOpen((o) => !o)} aria-haspopup="menu" aria-expanded={open} aria-label={'Page sound: ' + name + ' (press to change)'} title={'Page sound: ' + name + ' — press to change'}>
        <Icon />
      </button>
      {open && (
        <div className="info-card turn-list" role="menu" aria-label="Page sound">
          {SOUNDS.map((s) => (
            <button key={s.id} role="menuitemradio" aria-checked={s.id === value} className={s.id === value ? 'on' : ''} onClick={() => { onChange(s.id); setOpen(false); }}>
              {s.id === value ? '● ' : '○ '}{s.label}
            </button>
          ))}
        </div>
      )}
    </span>
  );
}
